export enum ExcelRowType {
  CHILD = 'child',
  PARENT = 'parent',
  AMBIGUOUS = 'ambiguous',
  INVALID = 'invalid',
}

export interface ExcelUploadIdentityRow {
  mainText: string;
  tagText: string;
  label: string;
  icon: string;
  isMetadata?: boolean;
}

export interface ExcelUploadIssue {
  csvLine: number;
  sku?: string | null;
  asin?: string | null;
  adId?: string | null;
  campaignName?: string | null;
  type?: 'error' | 'warning';
  rowType?: ExcelRowType;
  message: string;
  identities?: ExcelUploadIdentityRow[];
  [key: string]: any;
}

export interface ExcelUploadModalData {
  errors?: ExcelUploadIssue[];
  errorNumber?: number;
  totalCount?: number;
  successCount?: number;
  reportLink?: string | null;
  reportId?: string | null;
  reportColumns?: string[];
  title?: string;
}
